import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import UserPanelWide from "../../components/User/UserPanelWide";
import Section from "../../components/UI/Section/Section";
import ProfileTabs from "../../components/User/ProfileTabs";
import UserPanel from "../../components/User/UserPanel";

export default function Dashboard() {
  const [error, setError] = useState("");
  const { currentUser, logout } = useAuth();
  const history = useHistory();

  async function handleLogout() {
    setError("");

    try {
      await logout();
      history.push("/login");
    } catch {
      setError("Failed to log out");
    }
  }

  return (
    <>
      <UserPanel/>
      <Section>
        <ProfileTabs userID={currentUser.uid} />
      </Section>
      <UserPanelWide />
    </>
  );
}
